export default function DepartmentsController(
  $rootScope,
  $scope,
  $q,
  $filter,
  ssDialogService,
  alerts,
  loaderService,
  emDataService,
  confirmDialog,
  editDepartmentDialog,
) {
  const vm = this;

  vm.isExpanded = false;
  vm.handleAddDepartment = _handleAddDepartment;

  function _handleAddDepartment($event) {
    loaderService.showViewLoader = true;
    emDataService.getDefaultDepartment().then((getDepartmentResponse) => {
      try {
        ssDialogService.dialogs.enterpriseModeling.editDepartmentDialog = ssDialogService.alert(
          editDepartmentDialog.getOptions($event, {
            customerId: vm.customerId,
            department: getDepartmentResponse.data,
          })
        );
        ssDialogService.show(ssDialogService.dialogs.enterpriseModeling.editDepartmentDialog);
      } catch (error) {
        console.error(error);
      }
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }
}

DepartmentsController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  'ssDialogService',
  'alerts',
  'loaderService',
  'emDataService',
  'confirmDialog',
  'editDepartmentDialog',
  'editProcessDialog'
];
